/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
import { Group } from './Group';
const InvalidGroupExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['group', /* #__PURE__ */ parsers.maybeNull(Group)],
]), BaseError);
export class InvalidGroupException extends BaseError {
    static decode(input) {
        return InvalidGroupExceptionParser.decode(input).map(res => new InvalidGroupException(res));
    }
    static unsafeDecode(input) {
        return InvalidGroupException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InvalidGroupExceptionParser.encode(data);
    }
    static schema() {
        return InvalidGroupExceptionParser.schema();
    }
}
